export default {
  book: 'Réserver',
  close: 'Fermer',
  playReel: 'Lire la bobine',
  playVideo: 'Lire la vidéo',
  quickView: 'Aperçu rapide',
  contactUs: 'Contactez-nous',
  subscribe: "S'abonner",
  rotateDevice: 'Faites pivoter votre appareil',
  scrollToTop: 'Retour en haut de la page',
  backToHome: "Retour à l'accueil",
  discover: 'Découvrir',
  backToMenus: 'Retour aux menus',
  goToProduct: 'Voir le produit',
  askInfo: 'Demander des informations'
}
